<template>
  <CommonTabs
    class="mb-10"
    :id="$props.id"
    resource="user-groups"
    :tabs="tabs"
    :components="components"
    :default-router="defaultRouter"
    :breadcrumbs="breadcrumbs"
    :item-for-permission="userGroup"
  ></CommonTabs>
</template>

<script>
import CommonTabs from "../components/common/tabs/CommonTabs";
import UsersUserGroup from "./../components/user-groups/UsersUserGroup";
import DeleteUserGroup from "./../components/user-groups/DeleteUserGroup.vue";
import EditUserGroup from "./../components/user-groups/EditUserGroup.vue";
import NewUserGroup from "./../components/user-groups/NewUserGroup.vue";
import { title } from "../components/mixins/title";

export default {
  name: "UserGroup",
  mixins: [title],
  components: {
    CommonTabs
  },
  props: ["id"],
  data: () => ({
    tabs: [
      {
        title: "edit",
        component: "EditUserGroup",
        permissions: "user_group.read"
      },
      {
        title: "managers",
        component: "UsersUserGroup",
        permissions: "user_group.update",
        tabClass: {
          "pl-0": true,
          "tab-item-full-width": true,
          "tab-item-padding-0": true
        }
      },
      {
        title: "delete-title",
        component: "DeleteUserGroup",
        permissions: "user_group.delete"
      }
    ],
    components: {
      UsersUserGroup,
      DeleteUserGroup,
      EditUserGroup,
      NewUserGroup
    },
    defaultRouter: { name: "UserGroups" }
  }),

  computed: {
    userGroup: {
      get() {
        return this.$store.getters["userGroupStore/getItem"];
      }
    },
    breadcrumbs() {
      return this.userGroup.id
        ? [
            {
              text: this.$t("user-groups.user-groups"),
              to: {
                name: "User Groups"
              },
              exact: true
            },
            {
              text: this.userGroup.name,
              to: {
                name: "User Group",
                params: {
                  id: this.userGroup.id
                }
              },
              exact: true
            }
          ]
        : [];
    }
  },
  watch: {
    userGroup() {
      this.setTitle();
    }
  },
  methods: {
    getArgumentForTitle() {
      return {
        chain: [
          this.$t("user-groups.user-group"),
          this.$props.id ? this.userGroup.name : this.$t("user-groups.create")
        ]
      };
    }
  },
  mounted() {
    if (this.$props.id) {
      this.$store.dispatch("userGroupStore/get", {
        id: this.$props.id,
        onError: res => {
          // if system can't find user group redirect user to UserGroups page
          if (res.response.status === 404) {
            this.$router.push(this.defaultRouter);
          }
        }
      });
    } else {
      this.$store.commit("userGroupStore/set", { item: {} });
    }
  }
};
</script>
